import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Table, Spinner, Pagination, Alert } from 'react-bootstrap';
import api from '../lib/api';

function WidgetChatsPage() {
  const { token } = useParams();
  const [chats, setChats] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchChats = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await api.get(`/admin/widgets/chats/${token}/`, { params: { page } });
      const data = res.data || {};
      setChats(data.results || []);
      setTotalPages(Math.max(1, Math.ceil((data.count || 0) / 10)));
    } catch (err) {
      console.error(err);
      setError('Failed to fetch chats');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, token]);

  return (
    <Container className="pt-4">
      <h4 className="mb-4">💬 Widget Chat Logs</h4>

      {error && <Alert variant="danger">{error}</Alert>}
      {loading && <Spinner animation="border" className="mb-3" />}

      {!loading && chats.length > 0 ? (
        <>
          <Table bordered hover responsive size="sm" className="shadow-sm">
            <thead>
              <tr>
                <th>Date</th>
                <th>Guest</th>
                <th>Email</th>
                <th>Question</th>
                <th>Response</th>
                <th>👍/👎</th>
              </tr>
            </thead>
            <tbody>
              {chats.map((chat) => (
                <tr key={chat.id}>
                  <td>{new Date(chat.created_at).toLocaleString()}</td>
                  <td>{chat.guest_name || '-'}</td>
                  <td>{chat.email || '-'}</td>
                  <td>{chat.question}</td>
                  <td>{chat.response}</td>
                  <td>
                    {chat.feedback === 'positive' ? '👍' : chat.feedback === 'negative' ? '👎' : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Pagination>
            {Array.from({ length: totalPages }).map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === page}
                onClick={() => setPage(i + 1)}
                style={{ cursor: 'pointer' }}
              >
                {i + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      ) : !loading ? (
        <p>No chat logs yet for this widget.</p>
      ) : null}
    </Container>
  );
}

export default WidgetChatsPage;
